import { defineComponent as _defineComponent } from 'vue'
import { notificationProps, notificationEmits } from "./notification";
import { UiIconClose } from "../../icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'notification',
  props: notificationProps,
  emits: notificationEmits,
  setup(__props, { emit: emits }) {

const props = __props




return { __sfc: true,props, emits, UiIconClose }
}

})